import React from 'react';
import { Table } from './Table';
import { getColumnDefs, PAGE_SIZE } from './utils';
import { getApiParamsFromFilterModel } from '../utils';
import isEqual from 'lodash/isEqual';
import { getBudgetPerformance } from 'utils/apiRequests';

export class TableContainer extends React.Component {
	state = {
		data: [],
		totalCount: 0,
		isLoading: false,
		headers: [],
		page: 1,
		sortModel: null,
	};

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		const { tableDimension, filterModel } = this.props;

		if (
			tableDimension !== prevProps.tableDimension ||
			!isEqual(filterModel, prevProps.filterModel)
		) {
			this.setState({ page: 1 }, this.fetchData);
		}
	}

	getSortParams = () => {
		const { headers, sortModel } = this.state;

		if (!sortModel) {
			return {};
		}

		const column = headers.find(item => item.colName === sortModel.colId);

		return {
			sortDirection: sortModel && sortModel.sort,
			sortIndex: column && column.sortIndex,
		};
	};

	getApiParams = () => {
		const { page } = this.state;
		const { tableDimension, filterModel } = this.props;

		return {
			...this.getSortParams(),
			...getApiParamsFromFilterModel(filterModel),
			monthNumbers: filterModel.monthNumbers,
			type: tableDimension,
			take: PAGE_SIZE,
			skip: PAGE_SIZE * (page - 1),
		};
	};

	fetchData = () => {
		const { page, data } = this.state;

		this.setState({ isLoading: true });

		return getBudgetPerformance(this.getApiParams())
			.then(({ headers, body, totalCount }) => {
				this.setState({
					data: page === 1 ? body : [...data, ...body],
					headers,
					totalCount,
					isLoading: false,
				});
			})
			.catch(() => {
				this.setState({ isLoading: false });
			});
	};

	getColumnDefs = () => {
		const { sortModel } = this.state;
		const { tableDimension, spendFormatter } = this.props;

		return getColumnDefs(spendFormatter, sortModel, tableDimension);
	};

	handleLoadMore = () => {
		const { page } = this.state;

		this.setState({ page: page + 1 }, this.fetchData);
	};

	handleShowLess = () => {
		const { data, page } = this.state;

		this.setState({
			page: page - 1,
			data: [...data.slice(0, (page - 1) * PAGE_SIZE)],
		});
	};

	handleSortChanged = ([sortModel]) => {
		if (sortModel) {
			this.setState({ sortModel, page: 1 }, this.fetchData);
		}
	};

	render() {
		const { isLoading, data, totalCount } = this.state;
		const { spendFormatter } = this.props;

		return (
			<Table
				isLoading={isLoading}
				data={data}
				totalCount={totalCount}
				loadMore={this.handleLoadMore}
				onSortChanged={this.handleSortChanged}
				columnDefs={this.getColumnDefs()}
				spendFormatter={spendFormatter}
				onShowLess={this.handleShowLess}
			/>
		);
	}
}

export default TableContainer;
